import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/simp_at/step1';
import { AttributionFromFNSimple } from '../../models/AttributionFromFNSimple';
import {AvisInitialTypeLight} from "../../models/AvisInitialTypeLight";
@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {
	@Input() fnSimpleAttribution: AttributionFromFNSimple;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

	public rg1 = 'CTRL_IDWEB';

	public current_uid_avisInitial = 'AvisInitialType';

	public step1 = new Step1();

	constructor() {}

	public ngOnInit() {
		if(this.fnSimpleAttribution.avisInitial==null){
			this.fnSimpleAttribution.avisInitial=new AvisInitialTypeLight()
		}
		this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_idWebNames_json() }));
	}

	public getUid() {
		return this.uid;
	}

	public getUidAvisInitial() {
		return this.uid + '_SepSep_' + this.current_uid_avisInitial;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }
  
	getCtrl_idWebNames_json(): any {
	  return { idWeb: "_SepSep_AttributionFromFNSimple_SepSep_AvisInitialType_SepAtt_idWeb" };
	}
}
